import moment from 'moment';
import {
	checkHasApprovalHierarchy,
	fetchWithDifferntSearchName,
	getConfigValueDefaultingToTrue,
	getCurrency,
	getEntityById,
	getImageCountErrorRules,
	getObjectValues,
	getWarrantyStatus,
	isInternalTeam,
	isValidNumber,
	nullSafeGet,
	nullSafeGetOrElse,
	nullSafeToFixed,
} from '../../utils/DataAccessUtils';
import {
	getActiveAssetWarrantySupplierId,
	getActiveBuildingWarrantySupplierId,
} from '../../utils/WarrantyUtils';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
	Input,
	Select,
	Button,
	DatePicker,
	Modal,
	Radio,
	Popover,
	Row,
	InputNumber,
	Spin,
	message,
} from 'antd';
import { imageUploadValidation, normFile } from '../../utils/ImageUtils';
import BackButton from '../back_button/BackButton';
import * as React from 'react';
import _ from 'lodash';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import ProblemTypeTreeSelect from '../problem_type_tree_select';

import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import { assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import { SUB_ASSETS_TARGET_COLLECTION } from '../../reducers/assets_reducer';
import { spendCategoriesRestCrudThunksForBuyer } from '../../thunks/spend_categories_thunks';
import {
	problemTypesRestCrudThunksForBuyer,
	problemTypesHeirarchicalForBuyer,
} from '../../thunks/problem_types_thunks';
import { workOrderAttributesRestCrudThunksForBuyer } from '../../thunks/work_order_attributes_thunks';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesWithoutPMRestCrudThunksForBuyer,
} from '../../thunks/work_order_priorities_thunks';
import {
	approveWorkOrderForBuyer,
	workOrdersRestCrudThunksForBuyer,
} from '../../thunks/work_orders_thunks';
import { getProtectedImageUriForBuyer } from '../../utils/FileAccessUtils';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import {
	addWarrantySupplierToStoreState,
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	supplierFacilitiesRestCrudThunksForBuyer,
} from '../../thunks/supplier_facilities_thunks';
import { supplierPrivateNetworksV2ForBuyer } from '../../thunks/supplier_private_networks_thunks';
import SelfManagedSupplierEmailPromptModal from '../self_managed_supplier_email_prompt_modal/SelfManagedSupplierEmailPromptModal';
import {
	isSelfManagedSupplierEmailPromptEnabled,
	shouldPromptForSelfManagedSupplierEmail,
} from '../../utils/SelfManagedSupplierEmailPromptUtils';
import { suppliersRestCrudThunksForBuyer } from '../../thunks/suppliers_thunks';
import {
	PRE_SUPPLIER_ASSIGNMENT_STATUSES,
	WORK_ORDER_STATUSES,
} from '../../constants/WorkOrderStatuses';
import { buyersRestCrudThunksForBuyer } from '../../thunks/buyers_thunks';
import {
	areasRestCrudThunksForBuyer,
	fetchAreasWithHeirarchy,
	fetchDistinctAreasHeirarchy,
} from '../../thunks/areas_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import SupplierSelectionWorkOrderSelect from '../supplier_selection_work_order_select';
import { InfoCircleOutlined } from '@ant-design/icons';
import { projectsRestCrudThunksForBuyer } from '../../thunks/projects_thunks';
import {
	getProposalApprovalHierarchiesByAttributes,
	hasApprovalHierarchyChanged,
} from '../../thunks/company_approval_thunks';
import { BUYER_ADMIN_ONLY } from '../roles/roles';
import { debounce } from '../../utils/PerformanceUtils';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import {
	capexAssociationRestCrudThunksForBuyer,
	deleteCapexCategoryAssociation,
} from '../../thunks/capex_association_thunks';
import {
	rmAssociationRestCrudThunksForBuyer,
	deleteRmCategoryAssociation,
} from '../../thunks/rm_association_thunks';
import { getExchangeRate } from '../../thunks/currencies_thunks';
import { proposalsRestCrudThunksForBuyer } from '../../thunks/proposals_thunks';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import ApprovalHierarchyChangeModal from '../ApprovalHierarchyChangeModal';
import { resolutionTypesRestCrudThunksForBuyer } from '../../thunks/resolution_types_thunks';
import {
	getBuyerCompanySettingValue,
	isUserAllowedToAccess,
	isUserManagedBySupplier,
	PERMISSION_NAMES,
} from '../../utils/AuthUtils';
import OWRichTextEditor from '../../rich_text_editor/OWRichTextEditor';
import {
	getDueDate,
	getLocationWorkOrderAttributeFilters,
	getNewLocationNTE,
} from '../../utils/WorkOrderUtils';
import OWUpload from '../OWUpload';
import { isInApprovalHierarchy } from '../../utils/ApprovalHierarchyUtils';
import {
	FILTER_CONFIG_NAMES,
	FILTER_SEPARATOR,
	FILTER_VALUE_TYPE,
	ROLE_TYPES,
} from '../../utils/DataConstants';
import AssetWorkOrderSelect from '../asset_work_order_select/AssetWorkOrderSelect';
import SubAssetMultiSelect from '../sub_asset_multi_select/SubAssetMultiSelect';
import ClearErrors from '../clear_errors/ClearErrors';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import { invoicesRestCrudThunksForBuyer } from '../../thunks/invoices_thunks';
import { NTE_LOCKED_STATUSES } from '../../constants/InvoiceStatuses';
import WorkOrderIsPrivateFormItem from '../work_order_is_private_form_item/WorkOrderIsPrivateFormItem';
import { addBuyerSubscribersForBuyers } from '../../thunks/work_orders_subscribers_thunks';
import WOIsWarrantyFormField from './WOIsWarrantyFormField';
import CapExCategoryFormField from './CapExCategoryFormField';
import RMCategoryFormField from './RMCategoryFormField';
import AreaTreeSelect from '../area_tree_select/index';
import { withUserType } from '../withUserType';

const WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE = 'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE';
const WORK_ORDER_FORM_AREAS_AUTOCOMPLETE = 'WORK_ORDER_FORM_AREAS_AUTOCOMPLETE';
const WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE = 'WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE';
const WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE =
	'WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE';
const WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE =
	'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE';
const WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE = 'WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE';

interface WorkOrderFormProps extends FormComponentProps {
	history: any;
	onSubmit: any;
	onCancel: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	isApprovalForm?: any;
	creating: boolean;
	updating: boolean;
	formData: any;
	createErrors: any[];
	updateErrors: any[];
	fetchMultipleLocations: any;
	fetchLocations: any;
	fetchLocation: any;
	locations: any;
	fetchAsset: any;
	fetchMultipleAssets: any;
	fetchAssets: any;
	fetchBuyer: any;
	assets: any;
	fetchMultipleAreas: any;
	fetchAreas: any;
	areas: any;
	fetchMultipleProblemTypes: any;
	fetchProblemTypes: any;
	problemTypes: any;
	fetchMultipleSpendCategories: any;
	fetchSpendCategories: any;
	spendCategories: any;
	fetchWorkOrderAttributes: any;
	fetchMultipleWorkOrderPriorities: any;
	fetchWorkOrderPriorities: any;
	workOrderPriorities: any;
	supplierFacilities: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	currentUser: any;
	updateWorkOrderForm: any;
	fetchSupplierFacility: any;
	fetchSupplierRelationship: any;
	fetchSupplierCompany: any;
	fetchMultipleProjects: any;
	fetchProjects: any;
	projects: any;
	buyerProjectIds: any;
	fetchApprovalHeirarchy: any;
	addWarrantySupplier: any;
	companyConfig: any;
	saveCapExAssociation: any;
	deleteCapExAssociation: any;
	saveRmAssociation: any;
	deleteRmAssociation: any;
	fetchExchangeRate: any;
	getQuotes: any;
	fetchProblemType: any;
	getApprovalHierarchy: any;
	willApprovalHierarchyChange: any;
	resolutionTypes: any;
	fetchMultipleResolutionTypes: any;
	fetchResolutionTypes: any;
	approveWorkOrderForm: any;
	match: any;
	getInvoiceCounts: any;
	addBuyerSubscribers: any;
}

class WorkOrderEditForm extends React.Component<WorkOrderFormProps, any> {
	confirmChange: any = () => {};
	cancelChange: any = () => {};
	constructor(props) {
		super(props);

		let photosInfo;
		if (props.formData.images) {
			photosInfo = props.formData.images.map((p, idx) => {
				const [imgFileId, imgFileName] = p.split('/');
				const thumbUri = getProtectedImageUriForBuyer(imgFileId, imgFileName, 100, 100);
				const fullUri = getProtectedImageUriForBuyer(imgFileId, imgFileName, 400, 400);
				return {
					uid: idx,
					size: 1,
					name: imgFileName,
					filename: imgFileName,
					url: fullUri,
					status: 'done',
					thumbUrl: thumbUri,
					response: { data: { fileName: imgFileName, fileId: imgFileId } },
					type: 'image/jpeg',
				};
			});
		} else {
			photosInfo = [];
		}
		this.state = {
			workOrderApprovalHierarchy: nullSafeGet('formData.approvalHierarchy', props),
			hasApprovalHierarchy: nullSafeGet('formData.hasApprovalHierarchy', props),
			woChanges: {},
			woPriorityId: nullSafeGet('formData.woPriorityId', props),
			locationId: nullSafeGet('formData.locationId', props),
			assetId: nullSafeGet('formData.assetId', props),
			areaId: nullSafeGet('formData.areaId', props),
			problemTypeId: nullSafeGet('formData.problemTypeId', props),
			previewVisible: false,
			uploadLoading: false,
			previewImage: false,
			allPhotos: photosInfo,
			industryId: 1,
			isCapex: nullSafeGetOrElse('formData.isCapex', props, false),
			buyerProjectIds: nullSafeGetOrElse('formData.buyerProjectIds', props, 'false'),
			userApprovalInfo: {},
			showApprovalHierarchyChangeModal: false,
			buttonLoading: false,
			asset: nullSafeGet('formData.asset', props),
			warranty: nullSafeGet('formData.asset.warranties.0', props),
			supplierFacilityId: nullSafeGet('formData.supplierFacilityId', props),
			supplier: nullSafeGetOrElse('formData.supplierFacility', props, {}),
			location: nullSafeGetOrElse('formData.location', props, {}),
			exchangeRate: nullSafeGetOrElse(
				'currencyExchangeRateLocationToSupplier',
				this.props.formData,
				1
			),
			currencyExchangeRateBuyerToLocation: nullSafeGetOrElse(
				'currencyExchangeRateBuyerToLocation',
				this.props.formData,
				1
			),
			currentNTE: nullSafeGetOrElse('formData.nte', props, 0),
			locationNTE: nullSafeGetOrElse(
				'formData.nteInLocationCurrency',
				props,
				nullSafeGetOrElse('formData.nte', props, 0) /
					nullSafeGetOrElse('currencyExchangeRateLocationToSupplier', this.props.formData, 1)
			),
			hasQuote: false,
			numPicturesRequired: nullSafeGetOrElse(
				'problemType.serviceRequestNumPicturesRequired',
				this.props.formData,
				0
			),
			currentApprovalHierarchy: {},
			editorRef: React.createRef(),
			workOrderAttributesNTE: 0,
			isFinalApproval: false,
			invoiceDisallowsNTE: false,
			isPrivate: nullSafeGetOrElse('isPrivate', this.props.formData, 0),
			isPrivateModalVisible: false,
			isPrivateLoading: false,
			selfManagedSupplierEmailModalVisible: false,
			selfManagedSupplierEmailPromptSupplier: null,
			pendingSelfManagedSupplierEmailResolver: null,
		};
	}

	maybePromptForSelfManagedSupplierEmail = (supplier) => {
		const { companyConfig, fetchSupplierRelationship } = this.props;
		if (!isSelfManagedSupplierEmailPromptEnabled(companyConfig)) {
			return Promise.resolve(supplier);
		}
		return fetchSupplierRelationship({ supplierFacilityId: nullSafeGet('id', supplier) })
			.then((relationships) => {
				const relationship = relationships && relationships.length > 0 ? relationships[0] : null;
				if (!shouldPromptForSelfManagedSupplierEmail(companyConfig, supplier, relationship)) {
					return supplier;
				}
				return new Promise((resolve) => {
					this.setState({
						selfManagedSupplierEmailModalVisible: true,
						selfManagedSupplierEmailPromptSupplier: supplier,
						pendingSelfManagedSupplierEmailResolver: resolve,
					});
				});
			})
			.catch(() => supplier);
	};

	handleSelfManagedSupplierEmailInvited = (values) => {
		const { pendingSelfManagedSupplierEmailResolver, supplier } = this.state;
		const updatedSupplier = {
			...(supplier || {}),
			primaryContactEmail: values.primaryContactEmail,
		};
		this.setState(
			{
				supplier: updatedSupplier,
				selfManagedSupplierEmailModalVisible: false,
				selfManagedSupplierEmailPromptSupplier: null,
				pendingSelfManagedSupplierEmailResolver: null,
			},
			() => {
				if (pendingSelfManagedSupplierEmailResolver) {
					pendingSelfManagedSupplierEmailResolver(updatedSupplier);
				}
			}
		);
	};

	handleSelfManagedSupplierEmailSkipped = () => {
		const { pendingSelfManagedSupplierEmailResolver, supplier } = this.state;
		this.setState(
			{
				selfManagedSupplierEmailModalVisible: false,
				selfManagedSupplierEmailPromptSupplier: null,
				pendingSelfManagedSupplierEmailResolver: null,
			},
			() => {
				if (pendingSelfManagedSupplierEmailResolver) {
					pendingSelfManagedSupplierEmailResolver(supplier);
				}
			}
		);
	};

	isApproval = () => {
		const { isApprovalForm, currentUser, companyConfig } = this.props;
		const { hasApprovalHierarchy, workOrderApprovalHierarchy } = this.state;
		return (
			isApprovalForm &&
			(checkHasApprovalHierarchy({ hasApprovalHierarchy: hasApprovalHierarchy })
				? isInApprovalHierarchy(currentUser, workOrderApprovalHierarchy)
				: isUserAllowedToAccess(currentUser.userType)(
						PERMISSION_NAMES.CAN_APPROVE_WORK_ORDERS,
						companyConfig,
						currentUser.roles
				  ))
		);
	};

	getDefaultProblemTypeNTE(problemTypeId) {
		const { fetchWorkOrderAttributes } = this.props;

		fetchWorkOrderAttributes({
			problemTypeId,
			...getLocationWorkOrderAttributeFilters(this.state.location),
		}).then((workOrderAttributes) => {
			this.setState({ workOrderAttributes });
			nullSafeGet('0.NTEAmount', workOrderAttributes) &&
				this.setState({
					workOrderAttributesNTE: workOrderAttributes[0].NTEAmount,
				});
		});
	}

	componentDidMount() {
		const {
			fetchExchangeRate,
			formData,
			fetchBuyer,
			currentUser,
			form,
			getQuotes,
			getApprovalHierarchy,
			getInvoiceCounts,
		} = this.props;
		const { supplier, locationNTE } = this.state;

		const problemTypeId = nullSafeGet('problemType.id', formData);
		this.getDefaultProblemTypeNTE(problemTypeId);

		getInvoiceCounts({
			workOrderId: formData.id,
			statuses: NTE_LOCKED_STATUSES,
		}).then((count) => {
			this.setState({ invoiceDisallowsNTE: count > 0 });
		});

		getApprovalHierarchy({ isCapex: formData.isCapex, isPM: formData.isPM }).then((result) => {
			this.setState({ currentApprovalHierarchy: result }, () => {
				this.configureNTEWarningMessage();
			});
		});

		fetchBuyer(nullSafeGet('facility.buyerCompanyId', currentUser)).then((buyer) => {
			this.setState({ industryId: buyer.industryId });
		});

		this.initialCheckIsFinalApproval();

		getQuotes(
			{
				workOrderId: formData.id,
				supplierFacilityId: formData.supplierFacilityId,
			},
			'workOrderAssociatedQuotes'
		).then((proposals) => {
			if (proposals.length > 0) {
				this.setState({ hasQuote: true });
			} else {
				const supplierCurrency = getCurrency({ supplier });
				const workOrderCurrency = getCurrency({ workOrder: formData });
				if (supplierCurrency && workOrderCurrency && workOrderCurrency.id !== supplierCurrency.id) {
					//Should only be possible if Suppliers Currency has changed
					fetchExchangeRate(
						supplierCurrency.id,
						workOrderCurrency.id,
						currentUser.contactType
					).then((rate) =>
						this.setState(
							{
								exchangeRate: nullSafeGetOrElse('conversionRate', rate, 1),
								currentNTE: locationNTE * nullSafeGetOrElse('conversionRate', rate, 1),
							},
							() => {
								form.setFieldsValue({
									nteInLocationCurrency: locationNTE,
								});
							}
						)
					);
				}
			}
		});
	}
	configureNTEWarningMessage = () => {
		const { currentUser, form } = this.props;
		const { currentApprovalHierarchy, nextApprovalHierarchy } = this.state;
		const tiers = nullSafeGet('tierDetails', nextApprovalHierarchy || currentApprovalHierarchy);
		if (tiers && tiers.length > 0) {
			const userTier =
				_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) || tiers[0];
			this.setState(
				{
					userApprovalInfo: { amount: userTier.amountUpto || 1000000000 },
				},
				() => {
					form.validateFields();
				}
			);
		}
	};

	isWorkOrderSupplierPrivate = () => {
		const { supplier, supplierFacilityId } = this.state;
		return supplierFacilityId && nullSafeGetOrElse('status', supplier, 'active') === 'private';
	};

	getStatus = (supplierFacilityId, oldStatus) => {
		let newStatus;
		if (PRE_SUPPLIER_ASSIGNMENT_STATUSES.includes(oldStatus) && this.isWorkOrderSupplierPrivate()) {
			newStatus = WORK_ORDER_STATUSES.assignedToInternalTech;
		} else if (PRE_SUPPLIER_ASSIGNMENT_STATUSES.includes(oldStatus) && supplierFacilityId) {
			newStatus = WORK_ORDER_STATUSES.pendingConfirmationByServiceProvider;
		} else if (
			oldStatus === WORK_ORDER_STATUSES.supplierInitiatedPendingApproval &&
			supplierFacilityId
		) {
			newStatus = WORK_ORDER_STATUSES.confirmedByServiceProvider;
		} else if (!supplierFacilityId) {
			newStatus = WORK_ORDER_STATUSES.unassigned;
		} else {
			newStatus = oldStatus;
		}
		return newStatus;
	};

	deleteCapExCategoryAssociation = () => {
		const { formData, deleteCapExAssociation } = this.props;
		return formData.capExCategoryAssociationId
			? deleteCapExAssociation(formData.capExCategoryAssociationId)
			: new Promise((resolve) => resolve(true));
	};

	updateCapExCategory = (values) => {
		const { companyConfig, saveCapExAssociation } = this.props;
		if (nullSafeGetOrElse('config.capExConfig.acceptCapExCategory', companyConfig, false)) {
			return this.state.isCapex === true
				? saveCapExAssociation({
						workOrderId: values.id,
						...(nullSafeGet('capExCategoryInput.capExCategoryId', values) && {
							capExCategoryId: nullSafeGet('capExCategoryInput.capExCategoryId', values),
						}),
						capExCategory: nullSafeGetOrElse('capExCategoryInput.capExCategory', values, ''),
				  })
				: this.deleteCapExCategoryAssociation();
		} else return new Promise((resolve) => resolve(true));
	};

	deleteRmCategoryAssociation = () => {
		const { formData, deleteRmAssociation } = this.props;
		return formData.rmCategoryAssociationId
			? deleteRmAssociation(formData.rmCategoryAssociationId)
			: new Promise((resolve) => resolve(true));
	};

	updateRmCategory = (values) => {
		const { companyConfig, saveRmAssociation } = this.props;
		if (nullSafeGetOrElse('config.rmConfig.acceptRmCategory', companyConfig, false)) {
			return this.state.isCapex === false
				? saveRmAssociation({
						workOrderId: values.id,
						...(nullSafeGet('rmCategoryInput.rmCategoryId', values) && {
							rmCategoryId: nullSafeGet('rmCategoryInput.rmCategoryId', values),
						}),
						rmCategory: nullSafeGetOrElse('rmCategoryInput.rmCategory', values, ''),
				  })
				: this.deleteRmCategoryAssociation();
		} else return new Promise((resolve) => resolve(true));
	};

	getAdditionalInfo = () =>
		nullSafeGet('state.editorRef.current', this) &&
		(this.state.editorRef.current as any).getContent();

	handleSubmit = (e) => {
		const {
			form,
			history,
			redirectForwardUrl,
			onSuccess,
			updateWorkOrderForm,
			formData,
			approveWorkOrderForm,
		} = this.props;
		const { exchangeRate, supplier, location, currentNTE, hasQuote, isCapex } = this.state;

		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier });
		const workOrderCurrency = getCurrency({ workOrder: formData });
		e.preventDefault();
		form.validateFields((err, values) => {
			const nte = this.isWorkOrderSupplierPrivate() ? undefined : currentNTE || 0;
			const nteInLocationCurrency = this.isWorkOrderSupplierPrivate()
				? undefined
				: parseFloat(values.nteInLocationCurrency) || 0;
			if (!err) {
				// put image data into proper format to persist
				const picturesInfo = values.images.map((p) => {
					const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
					const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
					return `${fileId}/${fileName}`;
				});
				let workOrder = {
					...formData,
					id: values.id,
					title: values.title,
					status: this.isApproval()
						? this.getStatus(values.supplierFacilityId, values.status)
						: values.status,
					isPrivate: values.isPrivate,
					areaId: values.areaId ? parseInt(values.areaId, 10) : undefined,
					problemTypeId: parseInt(values.problemTypeId, 10),
					woPriorityId: parseInt(values.workOrderPriorityId, 10),
					locationId: parseInt(values.locationId, 10),
					assetId: values.assetId ? parseInt(values.assetId, 10) : undefined,
					...(values.assetId && {
						isAssetDown: values.isAssetDown === 'true' ? true : false,
					}),
					// Only include subAssetIds when the picker would have been visible — i.e.
					// an asset is selected AND the loaded asset has sub-assets. Sending
					// `null` (or stale ids) when the picker is hidden would either erase
					// the existing association or attach ids belonging to a prior parent.
					...(values.assetId && nullSafeGetOrElse('subAssetCount', this.state.asset, 0) > 0
						? {
								subAssetIds:
									Array.isArray(values.subAssetIds) && values.subAssetIds.length > 0
										? values.subAssetIds.map((id) => parseInt(id, 10))
										: null,
						  }
						: {}),
					images: picturesInfo,
					isCapex: isCapex,
					dueDate: values.dueDate,
					nte: nte,
					currencyId: !hasQuote ? supplierCurrency.id : workOrderCurrency.id,
					nteInLocationCurrency: nteInLocationCurrency,
					locationCurrencyId: locationCurrency.id,
					currencyExchangeRateLocationToSupplier:
						locationCurrency.id === supplierCurrency.id ? 1 : exchangeRate,
					description: this.getAdditionalInfo(),
					buyerFacilityId: values.buyerFacilityId,
					buyerCompanyId: values.buyerCompanyId,
					createdBy: values.createdBy,
					supplierFacilityId: values.supplierFacilityId,
					contractorDetails: values.contractorDetails,
					notes: values.notes,
					poNumber: values.poNumber,
					buyerAttachments: values.buyerAttachments,
					supplierAttachments: values.supplierAttachments,
					buyerProjectIds: values.buyerProjectIds,
					isWarranty: values.isWarranty === 'true',
					resolutionTypeId: values.resolutionType,
				};

				Promise.all([
					this.updateCapExCategory(values),
					this.updateRmCategory(values),
					this.isApproval() ? approveWorkOrderForm(workOrder) : updateWorkOrderForm(workOrder),
				]).then((results) => {
					redirectForwardUrl && history.push(redirectForwardUrl);
					results && results[2] && onSuccess && onSuccess(results[2]);
				});
			}
		});
	};

	handlePreview = (obj) => {
		let thumbUrl = null;
		let fullUrl = null;
		let photoInfo = null;
		if (obj.response.data) {
			const imgFileId = obj.response.data.fileId;
			const imgFileName = obj.response.data.fileName;
			thumbUrl = getProtectedImageUriForBuyer(imgFileId, imgFileName, 100, 100);
			fullUrl = getProtectedImageUriForBuyer(imgFileId, imgFileName, 400, 400);
			photoInfo = {
				uid: imgFileId,
				size: 1,
				name: imgFileName,
				filename: imgFileName,
				url: fullUrl,
				status: 'done',
				thumbUrl: thumbUrl,
				response: { data: { fileName: imgFileName, fileId: imgFileId } },
				type: 'image/jpeg',
			};
		}

		this.setState({
			photoInfo: [photoInfo],
			previewImage: fullUrl || thumbUrl,
			previewVisible: true,
		});
	};

	handleCancel = () => this.setState({ previewVisible: false });

	handleImageUpdate = (info) => {
		if (info.file.status === 'done') {
			this.setState({ allPhotos: info.fileList });
		} else if (info.file.status === undefined) {
			info.fileList = this.state.allPhotos;
		}
	};

	isAreaFilterAllowed = () => {
		const { companyConfig, currentUser } = this.props;
		return getBuyerCompanySettingValue(ROLE_TYPES.BUYER)(
			'assetConfig.allowAreaAssociationWithAssets',
			companyConfig,
			currentUser,
			false
		);
	};

	handleLocationChange = (locationId) => {
		const { fetchLocation } = this.props;
		const { supplier } = this.state;
		fetchLocation(locationId).then((loc) => {
			this.setState({ locationId: locationId, location: loc }, () => {
				new Promise((resolve, reject) => {
					resolve(this.checkBuyerToLocationCurrencyChange(loc));
				}).then(() => {
					this.checkCurrencyChange(loc, supplier);
				});
			});
		});
	};

	handleAreaChange = (areaId) => {
		this.setState({ areaId: areaId });
	};

	getProblemTypeRecord = (problemTypeId) => {
		return new Promise((resolve, reject) => {
			const { problemTypes, fetchProblemType } = this.props;
			const records = getRecordsForTargetCollection(
				problemTypes,
				WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE
			);
			const problemType = records.find((_) => _.id === problemTypeId);
			problemType
				? resolve(problemType)
				: fetchProblemType(problemTypeId)
						.then((res) => resolve(res))
						.catch((err) => reject(err));
		});
	};

	handleWorkOrderPriorityChange = (woPriorityId) => {
		const { form } = this.props;
		this.confirmChange = () => {
			this.setState({ woPriorityId }, () => {
				this.updateDueDate();
			});
		};
		this.cancelChange = () => {
			form.setFieldsValue({ workOrderPriorityId: this.state.woPriorityId });
		};
		this.changeApprovalHierarchyParamCheck({ woPriorityId: woPriorityId });
	};
	handleProblemTypeChange = (problemTypeId) => {
		const { form } = this.props;
		this.confirmChange = () => {
			this.setState({ problemTypeId });
			new Promise((resolve, reject) => {
				resolve(this.getDefaultProblemTypeNTE(problemTypeId));
			}).then(() => {
				this.resetNTE();
			});
			this.getProblemTypeRecord(problemTypeId).then((problemType) => {
				this.setState({
					numPicturesRequired: nullSafeGetOrElse(
						'serviceRequestNumPicturesRequired',
						problemType,
						0
					),
				});
			});
		};
		this.cancelChange = () => {
			form.setFieldsValue({ problemTypeId: this.state.problemTypeId });
		};
		this.changeApprovalHierarchyParamCheck({ problemTypeId: problemTypeId });
	};

	fetchSupplierData = (
		searchText = '',
		targetCollectionName = WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) => {
		const { addWarrantySupplier, fetchSupplierFacilitiesInPrivateNetwork, form } = this.props;
		const { asset, location, problemTypeId, isFinalApproval } = this.state;
		return new Promise((resolve, reject) =>
			fetchSupplierFacilitiesInPrivateNetwork(
				{ name: searchText, offset: 0, limit: 100 },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			).then((data) => {
				const assetSupplierId = getActiveAssetWarrantySupplierId(asset);
				const buildingSupplierId = getActiveBuildingWarrantySupplierId(location, problemTypeId);
				[assetSupplierId, buildingSupplierId].forEach((id) => {
					if (id && !data.some((supplier) => supplier && supplier.id === id)) {
						addWarrantySupplier(id, targetCollectionName);
					}
				});
				const supplierFacilityId = form.getFieldValue('supplierFacilityId');

				if (this.isApproval() && isFinalApproval && !supplierFacilityId && data.length > 0) {
					const defaultId = buildingSupplierId || assetSupplierId || nullSafeGet('0.id', data);
					form.setFieldsValue({ supplierFacilityId: defaultId });
				}
				resolve(data);
			})
		);
	};

	handleAssetChange = (assetId) => {
		const { fetchAsset, form } = this.props;
		form.setFieldsValue({ subAssetIds: [] });
		if (assetId) {
			fetchAsset(assetId).then((asset) => {
				this.setState(
					{
						assetId,
						asset,
						warranty: nullSafeGet('warranties.0', asset),
					},
					() => {
						this.resetNTE();
						this.fetchSupplierData();
					}
				);
			});
		} else {
			this.setState({ assetId: assetId, asset: undefined, warranty: undefined });
		}
	};

	calculateDueDate = () => {
		const { workOrderPriorities, form } = this.props;
		const { woPriorityId } = this.state;
		const woPriority = getEntityById(woPriorityId, workOrderPriorities);
		const currentDueDate = form.getFieldValue('dueDate');
		return getDueDate(woPriority, currentDueDate);
	};

	updateDueDate = () => {
		const { form } = this.props;
		form.setFieldsValue({ dueDate: this.calculateDueDate() });
	};

	assetWarranty = () => {
		const { asset, supplierFacilityId } = this.state;
		const assetWarrantyStatus = getWarrantyStatus(nullSafeGet('warranties.0', asset));
		const assetSupplierId = nullSafeGet('warranties.0.provider.supplierFacilityId', asset);
		const assetWarrantyNTE = nullSafeGet('warranties.0.NTEAmount', asset);

		return (
			assetWarrantyStatus === 'Active' && assetSupplierId === supplierFacilityId && assetWarrantyNTE
		);
	};

	checkBuyerToLocationCurrencyChange = (location) => {
		const { currentUser, fetchExchangeRate } = this.props;

		const locationCurrencyId = getCurrency({ location }).id;
		const buyerCurrencyId = getCurrency({ currentUser }).id;
		if (locationCurrencyId !== buyerCurrencyId) {
			fetchExchangeRate(locationCurrencyId, buyerCurrencyId, currentUser.contactType).then(
				(rate) => {
					this.setState({
						currencyExchangeRateBuyerToLocation: nullSafeGetOrElse('conversionRate', rate, 1),
					});
				}
			);
		} else {
			this.setState({ currencyExchangeRateBuyerToLocation: 1 });
		}
	};

	checkCurrencyChange = (location, supplierFacility) => {
		const { currentUser, fetchExchangeRate } = this.props;

		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier: supplierFacility });
		if (supplierCurrency && locationCurrency && locationCurrency.id !== supplierCurrency.id) {
			fetchExchangeRate(supplierCurrency.id, locationCurrency.id, currentUser.contactType).then(
				(rate) =>
					this.setState(
						{
							exchangeRate: nullSafeGetOrElse('conversionRate', rate, 1),
						},
						() => {
							this.resetNTE();
						}
					)
			);
		} else {
			this.resetNTE();
		}
	};

	//When some field has changed (supplier/asset/problem type), check what NTE should be.
	resetNTE = () => {
		const { form } = this.props;
		const {
			exchangeRate,
			locationNTE,
			workOrderAttributesNTE,
			supplier,
			currencyExchangeRateBuyerToLocation,
		} = this.state;

		const assetWarrantyNTE = this.assetWarranty();
		const hasSupplier = supplier && supplier.id !== undefined;
		const newLocationNTE = getNewLocationNTE(
			hasSupplier,
			this.isWorkOrderSupplierPrivate(),
			assetWarrantyNTE,
			locationNTE,
			workOrderAttributesNTE,
			currencyExchangeRateBuyerToLocation
		);
		this.setState(
			{
				currentNTE:
					isValidNumber(newLocationNTE) && isValidNumber(exchangeRate)
						? newLocationNTE * exchangeRate
						: undefined,
				locationNTE: newLocationNTE,
			},
			() => {
				form.setFieldsValue({
					nteInLocationCurrency: nullSafeToFixed(newLocationNTE),
				});
			}
		);
	};

	handleSupplierFacilityChange = (supplierFacilityId) => {
		const { fetchSupplierFacility, form } = this.props;
		const { location } = this.state;
		this.updateDueDate();
		if (supplierFacilityId) {
			fetchSupplierFacility(supplierFacilityId).then((supplierFacility) => {
				this.setState(
					{
						supplier: supplierFacility,
						supplierFacilityId,
					},
					() => {
						this.maybePromptForSelfManagedSupplierEmail(supplierFacility).then(
							(effectiveSupplier) => {
								if (!effectiveSupplier) {
									return;
								}
								this.checkCurrencyChange(location, effectiveSupplier);
							}
						);
					}
				);
			});
		} else {
			this.setState({ supplier: {}, locationNTE: undefined });
			form.setFieldsValue({ nteInLocationCurrency: undefined });
		}
	};

	handleAdditionalInfoChange = debounce(
		(additionalInfo) => {
			const { form } = this.props;
			form.setFieldsValue({ additionalInfo });
		},
		500,
		false
	);

	checkIsFinalApproval = (workOrderApproval) => {
		this.setState({
			isFinalApproval: !!workOrderApproval.isAlreadyApprovedOrWillBeApprovedIfCurrentUserApproves,
		});
	};

	initialCheckIsFinalApproval = () => {
		const { willApprovalHierarchyChange, formData } = this.props;
		willApprovalHierarchyChange(nullSafeGet('id', formData), {}).then((result) => {
			this.checkIsFinalApproval(nullSafeGetOrElse('workOrderApprovalChanges', result, {}));
		});
	};

	toggleIsPrivate = () => {
		const { formData, currentUser, addBuyerSubscribers } = this.props;
		if (this.state.isPrivate) {
			this.setState({ isPrivateModalVisible: true });
		} else {
			const subscriberEmails = [
				...nullSafeGetOrElse('supplierSubscriberEmails', formData, []),
				...nullSafeGetOrElse('buyerSubscriberEmails', formData, []),
			];
			const isUserSubscribed = subscriberEmails.includes(currentUser.email);

			if (!isUserSubscribed) {
				this.setState({ isPrivateLoading: true });
				addBuyerSubscribers(
					{
						id: formData.id,
						addBuyerSubscriberEmails: [currentUser.email],
					},
					formData
				)
					.then(() => this.setState({ isPrivate: true }))
					.catch((err) => message.error('Failed to make the work order private, please try again.'))
					.finally(() => {
						this.setState({ isPrivateLoading: false });
					});
			} else {
				this.setState({ isPrivate: true });
			}
		}
	};

	confirmIsPrivateModal = () => {
		this.setState({ isPrivateModalVisible: false, isPrivate: false });
	};

	cancelIsPrivateModal = () => {
		this.setState({ isPrivateModalVisible: false });
	};

	//param = {key: value}
	changeApprovalHierarchyParamCheck = (param) => {
		const { willApprovalHierarchyChange, formData, isApprovalForm } = this.props;
		const { woChanges } = this.state;
		const changes = { ...woChanges, ...param };

		this.setState({ buttonLoading: true, pendingParam: param });
		willApprovalHierarchyChange(nullSafeGet('id', formData), changes).then((result) => {
			//CHECKS TO SEE IF THEY HAVE CHANGED FROM THE INITIAL record.approvalHierarchy
			const quoteHierarchyChanged =
				nullSafeGetOrElse('quoteApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const quoteChanged =
				nullSafeGet('quoteApprovalChanges.hasApprovedByUsers', result) &&
				nullSafeGetOrElse('quoteApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const invoiceChanged =
				nullSafeGet('invoiceApprovalChanges.hasApprovedByUsers', result) &&
				nullSafeGetOrElse('invoiceApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const workOrderHierarchyChanged =
				nullSafeGetOrElse('workOrderApprovalChanges.changedHierarchy.length', result, 0) > 0 &&
				isApprovalForm; //If the work order has changed from the initial formData.approvalHierarchy
			const hasWorkOrderApprovalHierarchy = nullSafeGetOrElse(
				'workOrderApprovalChanges.hasApprovalHierarchy',
				result,
				false
			);
			this.checkIsFinalApproval(nullSafeGetOrElse('workOrderApprovalChanges', result, {}));

			this.setState({
				nextApprovalHierarchy: quoteHierarchyChanged
					? nullSafeGet('quoteApprovalChanges.changedHierarchy.0', result)
					: undefined,
				nextWorkOrderApprovalHierarchy: workOrderHierarchyChanged
					? nullSafeGet('workOrderApprovalChanges.changedHierarchy.0', result)
					: nullSafeGet('approvalHierarchy', formData),
				nextHasApprovalHierarchy: hasWorkOrderApprovalHierarchy,
			});
			if (quoteChanged || invoiceChanged || workOrderHierarchyChanged) {
				this.setState({
					showApprovalHierarchyChangeModal: true,
					approvalHierarchyChanges: [
						...(quoteChanged ? ['quote'] : []),
						...(invoiceChanged ? ['invoice'] : []),
						...(workOrderHierarchyChanged ? ['work order'] : []), //doesn't matter if approvers are present or not
					],
				});
			} else {
				this.changeApprovalHierarchyParamConfirm(param)();
				// this.configureNTEWarningMessage();
			}
		});
	};
	changeApprovalHierarchyParamConfirm = (param) => () => {
		const { woChanges } = this.state;
		this.confirmChange();
		this.setState(
			{
				...param,
				showApprovalHierarchyChangeModal: false,
				buttonLoading: false,
				pendingParam: undefined,
				workOrderApprovalHierarchy: this.state.nextWorkOrderApprovalHierarchy,
				nextWorkOrderApprovalHierarchy: undefined,
				hasApprovalHierarchy: this.state.nextHasApprovalHierarchy,
				nextHasApprovalHierarchy: undefined,
				woChanges: { ...woChanges, ...param },
			},
			() => {
				this.configureNTEWarningMessage();
			}
		);
	};
	changeApprovalHierarchyParamDismiss = () => {
		this.cancelChange();
		this.configureNTEWarningMessage();
		this.setState({
			showApprovalHierarchyChangeModal: false,
			buttonLoading: false,
			pendingParam: undefined,
			nextApprovalHierarchy: undefined,
			nextWorkOrderApprovalHierarchy: undefined,
			nextHasApprovalHierarchy: undefined,
		});
	};

	handleResolutionTypeChange = () => {};

	render() {
		const {
			updating,
			form,
			formData,
			locations,
			areas,
			problemTypes,
			workOrderPriorities,
			currentUser,
			fetchLocations,
			fetchMultipleLocations,
			fetchAreas,
			fetchMultipleAreas,
			fetchProblemTypes,
			fetchMultipleProblemTypes,
			fetchProjects,
			fetchMultipleProjects,
			fetchWorkOrderPriorities,
			fetchMultipleWorkOrderPriorities,
			supplierFacilities,
			fetchMultipleSupplierFacilitiesInPrivateNetwork,
			projects,
			companyConfig,
			resolutionTypes,
			fetchMultipleResolutionTypes,
			fetchResolutionTypes,
		} = this.props;

		const { getFieldDecorator, getFieldValue } = form;
		const {
			previewVisible,
			previewImage,
			assetId,
			warranty,
			exchangeRate,
			currencyExchangeRateBuyerToLocation,
			currentNTE,
			locationNTE,
			supplier,
			location,
			hasQuote,
			isCapex,
			userApprovalInfo,
		} = this.state;
		const dateFormat = 'dddd, MMM D, YYYY, h:mm A';
		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };
		const submitLabel = this.isApproval() ? 'Approve work order' : 'Update work order';
		const isAdmin = currentUser.roles.some((role) => BUYER_ADMIN_ONLY.has(role));
		const locationCurrency = getCurrency({ location });
		const workOrderCurrency = hasQuote
			? getCurrency({ workOrder: formData })
			: getCurrency({ supplier });
		const resolutionsFetching = nullSafeGet('fetching', resolutionTypes);
		const hasResolutionTypes = resolutionsFetching
			? true
			: getObjectValues(nullSafeGetOrElse('records', resolutionTypes, {})).length > 0;
		getFieldDecorator('id', { initialValue: formData.id });
		getFieldDecorator('createdAt', { initialValue: formData.createdAt });
		getFieldDecorator('notes', { initialValue: formData.notes });
		getFieldDecorator('buyerCompanyId', {
			initialValue: formData.buyerCompanyId || nullSafeGet('facility.buyerCompanyId', currentUser),
		});
		getFieldDecorator('createdBy', {
			initialValue: formData.createdBy || nullSafeGet('email', currentUser),
		});
		getFieldDecorator('contractorDetails', {
			initialValue: formData.contractorDetails || {
				contractorContacts: [],
			},
		});

		getFieldDecorator('problemTypeId', {
			initialValue: formData.problemTypeId,
		});
		getFieldDecorator('isCapex', {
			initialValue: formData.isCapex,
		});
		getFieldDecorator('buyerProjectIds', {
			initialValue: formData.buyerProjectIds,
		});

		getFieldDecorator('buyerAttachments', { initialValue: formData.buyerAttachments || [] });
		getFieldDecorator('supplierAttachments', { initialValue: formData.supplierAttachments || [] });

		const calculatedDueDate = formData.dueDate ? moment(formData.dueDate) : this.calculateDueDate();
		getFieldDecorator('dueDate', { initialValue: calculatedDueDate });

		const isImageUploading = (getFieldValue('images') || []).some((_) => _.status === 'uploading');
		const minPhotosCount = this.isApproval()
			? 0
			: nullSafeGetOrElse('state.numPicturesRequired', this, 0);

		const imageCountErrorMessage = `You need to upload at least ${minPhotosCount} photo${
			minPhotosCount > 1 ? 's' : ''
		}`;

		const poEntryEnabled = getConfigValueDefaultingToTrue(
			companyConfig,
			'config.workOrder',
			'allowPONUmberEntry'
		);

		const areaFilterAllowed = this.isAreaFilterAllowed();
		const subscriberEmails = [
			...nullSafeGetOrElse('supplierSubscriberEmails', formData, []),
			...nullSafeGetOrElse('buyerSubscriberEmails', formData, []),
		];
		const isUserSubscribed = subscriberEmails.includes(currentUser.email);

		//TODO: UPGRADE FORM
		return (
			<Form layout="vertical" onSubmit={this.handleSubmit} className="supplierForm">
				{this.state.selfManagedSupplierEmailModalVisible && (
					<SelfManagedSupplierEmailPromptModal
						visible
						showContext
						supplierFacility={this.state.selfManagedSupplierEmailPromptSupplier}
						onSkip={this.handleSelfManagedSupplierEmailSkipped}
						onInvited={this.handleSelfManagedSupplierEmailInvited}
					/>
				)}
				<ClearErrors actionCreators={WORK_ORDERS_CRUD_ACTION_CREATORS} />
				<Form.Item label="Title">
					{getFieldDecorator('title', {
						initialValue: formData.title,
						rules: [{ required: true, message: 'This field is required.' }],
					})(<Input style={{ maxWidth: 800 }} />)}
				</Form.Item>
				<Form.Item label="Incident Location">
					{getFieldDecorator('locationId', {
						initialValue: formData.locationId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<OWAsyncSelect
							style={{ maxWidth: 800 }}
							stateSlice={locations}
							targetCollectionName={WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleLocations(ids, targetCollectionName);
							}}
							onChange={this.handleLocationChange}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) => {
								fetchLocations(
									{ search: searchText || undefined },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(location) => (
								<Select.Option key={location.id} value={location.id}>
									{location.name}
								</Select.Option>
							)}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				<Form.Item
					label="Area"
					help={
						locations.fetching ||
						areas.fetching ||
						nullSafeGetOrElse('recordsIds.length', areas[WORK_ORDER_FORM_AREAS_AUTOCOMPLETE], 0) > 0
							? null
							: 'No areas are associated with this location'
					}
				>
					{getFieldDecorator('areaId', {
						initialValue: formData.areaId,
					})(
						<ProblemTypeTreeSelect
							style={{ maxWidth: 800 }}
							targetCollectionName={WORK_ORDER_FORM_AREAS_AUTOCOMPLETE}
							stateSlice={areas}
							allowClear
							fetchMultiple={fetchMultipleAreas}
							fetchData={fetchAreas}
							renderRecord={(area) => (
								<Select.Option key={area.id} value={area.id}>
									{area.name}
								</Select.Option>
							)}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
							additionalFilters={{
								locationId: nullSafeGet('locationId', this.state),
								brandId: nullSafeGet('location.brandId', this.state),
								problemTypeId: nullSafeGet('problemTypeId', this.state),
								...(nullSafeGet('location.locationTypeId', this.state) && {
									locationTypeId: nullSafeGet('location.locationTypeId', this.state),
								}),
							}}
						/>
					)}
				</Form.Item>
				<Form.Item required={true} label="Problem Type">
					{getFieldDecorator('problemTypeId', {
						initialValue: formData.problemTypeId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<ProblemTypeTreeSelect
							style={{ maxWidth: 800 }}
							mode="default"
							stateSlice={problemTypes}
							targetCollectionName={WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleProblemTypes(ids, targetCollectionName);
							}}
							onChange={this.handleProblemTypeChange}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) =>
								fetchProblemTypes(
									{ name: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								)
							}
							additionalFilters={{
								locationId: nullSafeGet('locationId', this.state),
								industryId: nullSafeGetOrElse('industryId', this.state, 1),
								brandId: nullSafeGet('location.brandId', this.state),
							}}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>

				<Form.Item label="Affected Asset">
					{getFieldDecorator('assetId', {
						initialValue: assetId,
					})(
						<AssetWorkOrderSelect
							onChange={this.handleAssetChange}
							additionalFilters={{
								locationId: nullSafeGetOrElse('locationId', this.state, formData.locationId),
								problemTypeId: nullSafeGetOrElse(
									'problemTypeId',
									this.state,
									formData.problemTypeId
								),
								...(areaFilterAllowed &&
									nullSafeGetOrElse('areaId', this.state, formData.areaId) && {
										areaIdOrNull: nullSafeGetOrElse('areaId', this.state, formData.areaId),
									}),
							}}
						/>
					)}
				</Form.Item>

				{nullSafeGetOrElse('subAssetCount', this.state.asset, 0) > 0 && (
					<Form.Item label="Sub Assets">
						{form.getFieldDecorator('subAssetIds', {
							initialValue: Array.isArray(formData.subAssetIds) ? formData.subAssetIds : [],
						})(
							<SubAssetMultiSelect
								parentAssetId={parseInt(this.state.assetId, 10)}
								fetchSubAssets={this.props.fetchSubAssets}
							/>
						)}
					</Form.Item>
				)}

				{nullSafeGet('assetId', formData) && (
					<Form.Item label="Is the asset functioning?">
						{form.getFieldDecorator('isAssetDown', {
							initialValue: formData.isAssetDown ? 'true' : 'false',
						})(
							<OWRadioGroup
								valueAccessor={(item) => item.value}
								renderRecord={(item) => item.label}
								items={[
									{
										label: 'Yes',
										value: 'false',
									},
									{
										label: 'No',
										value: 'true',
									},
								]}
							/>
						)}
					</Form.Item>
				)}

				<WOIsWarrantyFormField form={form} formData={formData} />

				<Form.Item label="Additional Info">
					{getFieldDecorator('additionalInfo', {
						initialValue: formData.description,
					})(
						<OWRichTextEditor
							initialEditorState={formData.description}
							editorRef={this.state.editorRef}
						/>
					)}
				</Form.Item>
				<Form.Item label="Photos">
					{getFieldDecorator(`images`, {
						valuePropName: 'fileList',
						getValueFromEvent: normFile,
						initialValue: this.state.allPhotos,
						rules: getImageCountErrorRules(minPhotosCount, imageCountErrorMessage),
					})(
						<OWUpload
							accept="image/*"
							name="file"
							listType="picture-card"
							className="workorder-image-uploader"
							multiple={true}
							headers={uploadHeaders}
							onPreview={this.handlePreview}
							action={`${BACKEND_URI}/api/v1/buyer/file/upload`}
							beforeUpload={imageUploadValidation}
							onChange={this.handleImageUpdate}
						>
							<div style={{ display: 'inline' }}>
								<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
								<div className="ant-upload-text">Upload</div>
							</div>
							<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
								<img alt="example" style={{ width: '100%' }} src={previewImage} />
							</Modal>
						</OWUpload>
					)}
				</Form.Item>
				{isInternalTeam(nullSafeGet('supplier', this.state)) ? null : (
					<div className={'flex flex-row'}>
						<Form.Item
							label="NTE"
							validateStatus={userApprovalInfo.status}
							help={
								userApprovalInfo.status ? (
									<div
										style={{ width: 1000 }}
										className={'absolute flex flex-row flex-nowrap'}
									>{`This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto ${locationCurrency.format(
										userApprovalInfo.amount * currencyExchangeRateBuyerToLocation
									)}`}</div>
								) : this.state.invoiceDisallowsNTE ? (
									<div style={{ width: 1000 }} className={'absolute flex flex-row flex-nowrap'}>
										{'The NTE cannot be changed while an invoice exists and is not disputed.'}
									</div>
								) : (
									''
								)
							}
						>
							{getFieldDecorator('nteInLocationCurrency', {
								initialValue: locationNTE,
								validateTrigger: 'onChange',
								rules: [
									{
										validator: (rule, value, callback) => {
											if (
												userApprovalInfo.amount &&
												parseFloat(value) / currencyExchangeRateBuyerToLocation >
													parseFloat(userApprovalInfo.amount) &&
												parseFloat(value) / currencyExchangeRateBuyerToLocation !== formData.nte
											) {
												this.setState({
													userApprovalInfo: {
														...userApprovalInfo,
														status: isAdmin ? 'warning' : 'error',
													},
												});
												callback(isAdmin ? undefined : '');
											} else {
												this.setState({
													userApprovalInfo: {
														...userApprovalInfo,
														status: null,
													},
												});
												callback();
											}
										},
									},
								],
							})(
								<InputNumber
									style={{ width: 200 }}
									disabled={this.isWorkOrderSupplierPrivate() || this.state.invoiceDisallowsNTE}
									addonAfter={locationCurrency.id}
									onChange={(value: any) =>
										this.setState({
											locationNTE: value,
											currentNTE: value * exchangeRate,
										})
									}
								/>
							)}
						</Form.Item>
						{workOrderCurrency &&
						locationCurrency &&
						workOrderCurrency.id !== locationCurrency.id &&
						!this.isWorkOrderSupplierPrivate() ? (
							<div className="flex flex-row" style={{ marginTop: 30 }}>
								<i
									className="icons8-font icons8-data-transfer"
									style={{ fontSize: 24, marginTop: 2, marginRight: 26 }}
								/>
								<InputNumber
									style={{ width: 200, height: 38 }}
									disabled={true}
									value={nullSafeToFixed(currentNTE)}
									addonAfter={workOrderCurrency.id}
								/>
							</div>
						) : null}
					</div>
				)}
				<ApprovalHierarchyChangeModal
					visible={this.state.showApprovalHierarchyChangeModal}
					onOk={this.changeApprovalHierarchyParamConfirm}
					param={this.state.pendingParam}
					onCancel={this.changeApprovalHierarchyParamDismiss}
					approvalHierarchyChanges={this.state.approvalHierarchyChanges}
				/>
				<Form.Item label="Expense Type">
					{getFieldDecorator('isCapex', {
						initialValue: formData.isCapex ? 'true' : 'false',
					})(
						<Row>
							<Spin spinning={this.state.buttonLoading}>
								<Radio.Group value={isCapex} style={{ display: 'flex' }}>
									{/* {isCapex === false ? (
										<Radio.Button style={{ flexWrap: 'nowrap' }} value={false} onClick={() => {}}>
											R&M
										</Radio.Button>
									) : ( */}
									<Radio.Button
										style={{ flexWrap: 'nowrap' }}
										value={false}
										onClick={() => this.changeApprovalHierarchyParamCheck({ isCapex: false })}
									>
										R&M
									</Radio.Button>
									{/* )} */}
									{/* {isCapex === true ? (
										<Radio.Button style={{ flexWrap: 'nowrap' }} value={true} onClick={() => {}}>
											CapEx
										</Radio.Button>
									) : ( */}
									<Radio.Button
										style={{ flexWrap: 'nowrap' }}
										value={true}
										onClick={() => this.changeApprovalHierarchyParamCheck({ isCapex: true })}
									>
										CapEx
									</Radio.Button>
									{/* )} */}
								</Radio.Group>
							</Spin>
							<Popover
								content={
									<div>
										<Row>
											<span style={{ fontSize: '20px' }}>Repair and Maintenance (R&M)</span>
										</Row>
										<Row>
											<span>Costs associated with repair and maintenance of existing assets</span>
										</Row>
										<Row style={{ height: '20px' }}></Row>
										<Row>
											<span style={{ fontSize: '20px' }}>Capital Expenditures (CapEx)</span>
										</Row>
										<Row>
											<span>
												Costs associated with buying new assets or upgrading existing assets
											</span>
										</Row>
									</div>
								}
							>
								<InfoCircleOutlined
									style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}
								/>
							</Popover>
						</Row>
					)}
				</Form.Item>
				<CapExCategoryFormField
					isCapex={isCapex}
					getFieldDecorator={getFieldDecorator}
					formData={formData}
				/>
				<RMCategoryFormField
					isCapex={isCapex}
					getFieldDecorator={getFieldDecorator}
					formData={formData}
				/>
				<WorkOrderIsPrivateFormItem
					form={form}
					currentUser={currentUser}
					workOrder={formData}
					isPrivate={this.state.isPrivate}
					isPrivateModalVisible={this.state.isPrivateModalVisible}
					isPrivateLoading={this.state.isPrivateLoading}
					toggleIsPrivate={this.toggleIsPrivate}
					confirmIsPrivateModal={this.confirmIsPrivateModal}
					cancelIsPrivateModal={this.cancelIsPrivateModal}
				/>
				<Form.Item label="Priority">
					{getFieldDecorator('workOrderPriorityId', {
						initialValue: formData.woPriorityId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<OWAsyncSelect
							style={{ maxWidth: 800 }}
							stateSlice={workOrderPriorities}
							targetCollectionName={WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleWorkOrderPriorities(ids, targetCollectionName);
							}}
							onChange={this.handleWorkOrderPriorityChange}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting = {
									sort_by: 'expectedResolutionInSeconds',
									order: 'descend',
								},
								filters,
								addToTargetCollection
							) => {
								fetchWorkOrderPriorities(
									{ name: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(workOrderPriority) => (
								<Select.Option key={workOrderPriority.id} value={workOrderPriority.id}>
									{workOrderPriority.name}
								</Select.Option>
							)}
						/>
					)}
				</Form.Item>
				<Form.Item label="Supplier" hidden={isUserManagedBySupplier(currentUser)}>
					{getFieldDecorator('supplierFacilityId', {
						initialValue: formData.supplierFacilityId,
					})(
						<SupplierSelectionWorkOrderSelect
							disabled={false}
							style={{ maxWidth: 800 }}
							allowClear={true}
							stateSlice={supplierFacilities}
							targetCollectionName={
								WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE
							}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleSupplierFacilitiesInPrivateNetwork(ids, targetCollectionName);
							}}
							warrantySupplierId={getActiveAssetWarrantySupplierId(this.state.asset)}
							buildingWarrantySupplierId={getActiveBuildingWarrantySupplierId(
								this.state.location,
								this.state.problemTypeId
							)}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) =>
								this.fetchSupplierData(
									searchText,
									targetCollectionName,
									pagination,
									(sorting = {}),
									filters,
									addToTargetCollection
								)
							}
							onChange={this.handleSupplierFacilityChange}
							additionalFilters={{
								problemTypeId: this.state.problemTypeId,
								locationId: this.state.locationId,
							}}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				<Form.Item label="Due date">
					{getFieldDecorator('dueDate', {
						rules: [{ required: true, message: 'This field is required.' }],
					})(<DatePicker style={{ width: 300 }} format={dateFormat} showTime={true} />)}
				</Form.Item>
				{poEntryEnabled ? (
					<Form.Item label="PO Number">
						{getFieldDecorator('poNumber', {
							initialValue: formData.poNumber,
						})(<Input style={{ maxWidth: 300 }} />)}
					</Form.Item>
				) : null}
				<Form.Item label="Project">
					{getFieldDecorator('buyerProjectIds', {
						initialValue: formData.buyerProjectIds,
					})(
						<OWAsyncSelect
							style={{ maxWidth: 800 }}
							mode={'multiple'}
							stateSlice={projects}
							targetCollectionName={WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleProjects(ids, targetCollectionName);
							}}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) => {
								fetchProjects(
									{ search: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(project) => (
								<Select.Option key={project.id} value={project.id}>
									{project.title}
								</Select.Option>
							)}
						/>
					)}
				</Form.Item>
				{hasResolutionTypes ? (
					<Form.Item label="Resolution Type">
						{getFieldDecorator('resolutionType', {
							initialValue: formData.resolutionTypeId,
						})(
							<OWAsyncSelect
								style={{ maxWidth: 800 }}
								stateSlice={resolutionTypes}
								targetCollectionName={'RESOLUTION_TYPES_AUTOCOMPLETE'}
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleResolutionTypes(ids, targetCollectionName);
								}}
								onChange={this.handleResolutionTypeChange}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchResolutionTypes(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(resolutionType) => (
									<Select.Option key={resolutionType.id} value={resolutionType.id}>
										{resolutionType.resolutionCode ? `${resolutionType.resolutionCode} - ` : null}
										{resolutionType.resolutionType}
									</Select.Option>
								)}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
								allowClear
							/>
						)}
					</Form.Item>
				) : null}
				{getFieldDecorator('status', {
					initialValue: formData.status,
				})}
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						loading={updating || isImageUploading}
						className="contactForm__button"
					>
						{submitLabel}
					</Button>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,
	isApprovalForm: ownProps.isApprovalForm,
	createErrors: state.work_orders.createErrors,
	updateErrors: state.work_orders.updateErrors,
	formData: ownProps.formData,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
	locations: state.locations,
	assets: state.assets,
	areas: state.areas,
	problemTypes: state.problem_types,
	spendCategories: state.spend_categories,
	workOrderPriorities: state.work_order_priorities,
	projects: state.projects,
	supplierFacilities: state.supplier_facilities,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
	resolutionTypes: state.resolution_types,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForBuyer.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleResolutionTypes: (ids, targetCollectionName) =>
		dispatch(resolutionTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchResolutionTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			resolutionTypesRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
	fetchSubAssets: (parentId) =>
		dispatch(
			assetsRestCrudThunksForBuyer.read(
				{ parentIds: parentId },
				SUB_ASSETS_TARGET_COLLECTION,
				{ current: 1, pageSize: 1000 },
				{ sort_by: 'name', order: 'ascend' }
			)
		),
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			dispatch(
				assetsRestCrudThunksForBuyer.readLite(
					{ ...params, view: 'workOrderCreation' },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			)
		),
	fetchBuyer: (id) => dispatch(buyersRestCrudThunksForBuyer.readOne(id)),
	fetchMultipleProblemTypes: (ids, targetCollectionName) =>
		dispatch(problemTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			problemTypesHeirarchicalForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleSpendCategories: (ids, targetCollectionName) =>
		dispatch(spendCategoriesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchSpendCategories: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			spendCategoriesRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchWorkOrderAttributes: (params) =>
		dispatch(workOrderAttributesRestCrudThunksForBuyer.read(params)),
	fetchMultipleProjects: (ids, targetCollectionName) =>
		dispatch(projectsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchProjects: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			projectsRestCrudThunksForBuyer.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
		dispatch(workOrderPrioritiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchWorkOrderPriorities: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			workOrderPrioritiesWithoutPMRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection
	) =>
		dispatch(
			fetchSupplierFacilitiesInPrivateNetworkForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleSupplierFacilitiesInPrivateNetwork: (ids, targetCollectionName) =>
		dispatch(supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	updateWorkOrderForm: (workOrder) => dispatch(workOrdersRestCrudThunksForBuyer.update(workOrder)),
	approveWorkOrderForm: (workOrder) => dispatch(approveWorkOrderForBuyer(workOrder)),
	fetchSupplierFacility: (id) => dispatch(supplierFacilitiesRestCrudThunksForBuyer.readOne(id)),
	fetchSupplierRelationship: (params) => dispatch(supplierPrivateNetworksV2ForBuyer(params)),
	fetchSupplierCompany: (id) => dispatch(suppliersRestCrudThunksForBuyer.readOne(id)),
	addWarrantySupplier: (supplierId, targetCollectionName) =>
		dispatch(addWarrantySupplierToStoreState(supplierId, targetCollectionName)),
	saveCapExAssociation: (entity) => dispatch(capexAssociationRestCrudThunksForBuyer.create(entity)),
	deleteCapExAssociation: (id) => dispatch(deleteCapexCategoryAssociation(ROLE_TYPES.BUYER)(id)),
	saveRmAssociation: (entity) => dispatch(rmAssociationRestCrudThunksForBuyer.create(entity)),
	deleteRmAssociation: (id) => dispatch(deleteRmCategoryAssociation(ROLE_TYPES.BUYER)(id)),
	fetchExchangeRate: (c1, c2, userType) => dispatch(getExchangeRate(c1, c2)(userType)),
	getQuotes: (params, targetCollectionName) =>
		dispatch(proposalsRestCrudThunksForBuyer.read(params, targetCollectionName)),
	fetchProblemType: (id) => dispatch(problemTypesRestCrudThunksForBuyer.readOne(id)),
	getApprovalHierarchy: (params) =>
		dispatch(getProposalApprovalHierarchiesByAttributes('buyer', params)),
	willApprovalHierarchyChange: (workOrderId, params) =>
		dispatch(hasApprovalHierarchyChanged('buyer', workOrderId, params)),
	fetchLocation: (id) => dispatch(locationsRestCrudThunksForBuyer.readOne(id)),
	getInvoiceCounts: (params) =>
		dispatch(invoicesRestCrudThunksForBuyer.countBy(params, 'invoice_counts')),
	addBuyerSubscribers: (obj, workOrder) => dispatch(addBuyerSubscribersForBuyers(obj)(workOrder)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			fetchAreasWithHeirarchy(ROLE_TYPES.BUYER)(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
});

export default withUserType(
	withRouter(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(Form.create<WorkOrderFormProps>()(WorkOrderEditForm))
	)
);
